const NotFound = () => null;

export default NotFound;
